import styled from "styled-components";

export const ItemWrapper = styled.div`
  & a {
    color: var(--text);
    &:hover {
      color: var(--highlight);
    }
  }
  & > div {
    display: flex;
    width: 100%;
    & > div {
      padding: var(--insidePadding);
    }
    & > div:first-of-type {
      flex: 2;
      & + div {
        flex: 1;
      }
    }
    & + div {
      padding: var(--insidePadding);
    }
    & h2 {
      margin: 0;
    }
    @media (max-width: 1023px) {
      flex-direction: column;
      & > div:first-of-type {
        flex: 1;
      }
    }
  }
  /* max-width: calc(100vw - var(--outsidePadding) - var(--outsidePadding)); */
  /* overflow-y: scroll; */
  & table {
    font-family: var(--headerFont);
    & tr > td:first-of-type {
      white-space: nowrap;
    }
    & td {
      vertical-align: top;
      &:first-of-type {
        font-weight: bold;
      }
      & + td {
        padding-left: var(--insidePadding);
      }
      & a {
        text-decoration: none;
        transition: 0.5s;
        color: var(--text);
        &:hover {
          color: var(--highlight);
          text-decoration: underline;
        }
      }
      & ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        font-family: var(--headerFont);
        & > li {
          display: inline-block;
          &:after {
            content: "·";
            margin-left: 8px;
            margin-right: 8px;
          }
          &:last-of-type {
            &:after {
              content: "";
            }
          }
          & a {
            font-weight: bold;
          }
        }
      }
    }
  }
`;

export const ImageDataDiv = styled.div`
  & > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    & > li {
      display: inline;
      & a {
        color: var(--text);
        &:hover {
          color: var(--highlight);
        }
      }
      & + li {
        &:before {
          content: ", ";
        }
      }
    }
  }
`;

export const NotesP = styled.div`
  font-size: 1.2em;
  margin: 1em 0;
`;

export const CollectionText = styled.p`
  font-size: 0.8em;
`;

export const FullNameText = styled.p`
  font-weight: bold;
`;
